/* *************************************************************** *
 * THIS IS AN AUTO GENERATED FILE. PLEASE DO NOT EDIT IT DIRECTLY.
 *
 * If you want to change this Icon component , it is generated
 * from the `iconTamplate.js` file the parent directory.
 * *************************************************************** */
/* eslint-disable */
import React from 'react';
import { useFela, } from 'react-fela';
import iconStyle from '../iconStyle';
import { iconPropTypes, iconDefaultProps, } from '../iconPropTypes';

export default function IconWhatsapp({ size, fill, color, attrs, miscStyles, ...props }) {
  const className = useFela({ size, fill, color, miscStyles, }).css(iconStyle);

  return (
    <svg width="1em" height="1em" viewBox="0 0 256 256" className={className} {...props} {...attrs} data-test="IconWhatsapp">  <path fill="currentColor" d="M206.6 80.7c-19.2-31.4-56.1-47.1-91.7-38.6-29.2 7-49.8 24.6-60.7 52.9-9.7 25-7.3 49.5 5.6 73 .5.9.7 2.3.4 3.2-3.2 9.7-14.3 38.9-16.2 44.1 1.6-.6 32.4-9.9 47-14.5.9-.3 2.1-.3 2.8.1 8.7 4.5 17.8 7.6 27.4 9 14.9 2.2 29.4.9 43.3-4.8 30-12.3 48.3-34.6 53.7-67 3.4-20.4-.8-39.7-11.6-57.4zm-59.3 78.4c-10.7-3.5-20.6-8.3-28.8-16.2-8.8-8.5-16.6-17.8-21.7-29.1-4-9-3.9-17.9 2.3-26.1 2.6-3.4 5.2-4.9 10.4-5.3 4-.4 5.6 1.7 6.9 5.1 1.7 4.5 3.6 9 5.6 13.5 1 2.3.8 4.3-.6 6.2-1.4 1.9-2.8 3.7-4.4 5.4-1.5 1.6-1.5 3.1-.4 4.8 6.3 10.4 14.7 18.4 25.9 23.3 5.2 2.3 5.2 2.4 8.8-2 1.5-1.8 3-3.7 4.4-5.6 1.3-1.7 2.8-4 4.7-3.2 5.6 2.7 11.2 7.3 16.8 9.9 1.4.7 2 1.7 2 3.3.1 8.7-5.9 15.8-14.6 17.8-6.1 1.6-11.7.1-17.3-1.8z" /></svg>
  );
}

IconWhatsapp.propTypes = iconPropTypes;
IconWhatsapp.defaultProps = iconDefaultProps;
